import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Location } from '../models/location';

@Injectable({
  providedIn: 'root'
})
export class Containersvice {

  public url: string;
  public token;
  public headers;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  save(json): Observable<any> {
    if (json.id === null) {
      return this.create(json);
    } else {
      return this.update(json);
    }
  }

  create(json): Observable<any> {
    return this.petition(`${this.url}/container/new`, json);
  }

  update(json): Observable<any> {
    return this.petition(`${this.url}/container/edit/${json.id}`, json);
  }

  showAll(
    activo?: any,
    page?: any,
    perPage?: any,
    filtros: any[] = [],
    order?: any
  ): Observable<any> {


        order = order ?? [];
        const json = JSON.stringify(order);

        this.token = JSON.parse(localStorage.getItem('token'));
        let params = `authorization=${this.token}`;

         if (order) {
            params += `&order=${encodeURIComponent(json)}`;
          }

        if (activo) {
            params += `&activo=${encodeURIComponent(JSON.stringify(activo))}`;
          }

       
        let headers = new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        });
   
        page = page ?? 1;
        perPage = perPage ?? 10;
    
        let queryParams = `?page=${page}&perpage=${perPage}`;
        filtros.forEach(filtro => {
          if (filtro && filtro.value) {
            queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
            if (filtro.key_type) {
              queryParams += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
            }
          }
        });
    
    //return this.petition(`${this.url}/container/list`);
     return this._http.post<any>(
      `${this.url}/container/list${queryParams}`,
      params,
      { headers: headers }
    ).pipe(
      map((res: any) => res)
    );

  }

  showOne(id: any): Observable<any> {
    return this.petition(`${this.url}/container/detail/${id}`);
  }

  delete(id?: any, active?: any, masive?: any): Observable<any> {

      let params = `authorization=${this.token}`;

       if (active) {
            params += `&activo=${encodeURIComponent(JSON.stringify(active))}`;
          }

        if(masive){
          params += `&masive=${encodeURIComponent(JSON.stringify(masive))}`;
        }

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post(`${this.url}/container/remove/${id}?`, params, {
        headers: headers,
      })
      .pipe(map((res) => res));
   // return this.petition(`${this.url}/container/remove/${id}`);
  }

  deleteBulk(bulk: Array<any>): Observable<any> {
    const json = {
      bulk: bulk
    };
    return this.petition(`${this.url}/container/bulkremove`, json);
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    
    let params, response;
    params = `authorization=${this.token}`;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = `${params}&json=${json}`;
    }

    if (type != null) {
      params = `${params}&type=${type}`;
    }

    response = this._http.post(
      url,
      params,
      { headers: this.headers }
    ).pipe(map(res => res));

    if (response.code === 404) {
      // this.mtds.notifyError('Your session has expired');
      localStorage.clear();
      // this._router.navigate(['/pages/lock']);
    }

    return response;
  }
}
